export function getFirstAndLastName(fullName: string) {
  if (!fullName) return null;

  const names = fullName.split(' ');
  const firstName = names[0];
  const lastName = names.length > 1 ? names[names.length - 1] : '';

  return { firstName, lastName };
}
